import { Link, Navigate, useLocation } from "react-router-dom";
import {
  FiAlertCircle,
  FiCheckCircle,
  FiInfo,
  FiMail,
} from "react-icons/fi";
import PageContainer from "../components/layout/PageContainer";
import SectionTitle from "../components/common/SectionTitle";
import Button from "../components/common/Button";

const STATUS_CONFIG = {
  success: {
    icon: FiCheckCircle,
    iconClassName: "text-green-600",
    cardClassName: "border border-green-200 bg-green-50",
  },
  email: {
    icon: FiMail,
    iconClassName: "text-[#8B3A3A]",
    cardClassName: "border border-[#d7c2a3] bg-[#faf6ef]",
  },
  info: {
    icon: FiInfo,
    iconClassName: "text-[#8B3A3A]",
    cardClassName: "border border-[#d7c2a3] bg-[#faf6ef]",
  },
  error: {
    icon: FiAlertCircle,
    iconClassName: "text-red-600",
    cardClassName: "border border-red-200 bg-red-50",
  },
};

const ActionStatus = () => {
  const location = useLocation();
  const state = location.state;

  if (!state) {
    return <Navigate to="/" replace />;
  }

  const {
    status = "info",
    eyebrow = "Update",
    title = "Status",
    message = "",
    note = "",
    details = [],
    actions = [],
  } = state;

  const config = STATUS_CONFIG[status] || STATUS_CONFIG.info;
  const Icon = config.icon;

  return (
    <div className="page-section">
      <PageContainer width="md">
        <div className="mx-auto max-w-3xl content-card-lg p-8">
          <SectionTitle
            eyebrow={eyebrow}
            title={title}
            subtitle={message}
            align="center"
            className="mb-8"
          />

          <div className={`rounded-3xl p-6 ${config.cardClassName}`}>
            <div className="flex flex-col items-center text-center">
              <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-sm">
                <Icon size={30} className={config.iconClassName} />
              </div>

              {note ? (
                <p className="max-w-2xl text-sm leading-7 text-[#3b2f2f]">
                  {note}
                </p>
              ) : null}
            </div>

            {Array.isArray(details) && details.length > 0 ? (
              <div className="mt-8 rounded-2xl bg-white p-5">
                <h2 className="text-lg font-semibold text-[#8B3A3A]">
                  Helpful Details
                </h2>

                <div className="mt-4 grid gap-4 md:grid-cols-2">
                  {details.map((detail, index) => (
                    <div
                      key={`${detail.label}-${index}`}
                      className="rounded-2xl border border-[#eadfce] bg-[#fffdfa] p-4"
                    >
                      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#a87f49]">
                        {detail.label}
                      </p>
                      <p className="mt-2 text-sm leading-6 text-[#3b2f2f]">
                        {detail.value || "—"}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}

            {Array.isArray(actions) && actions.length > 0 ? (
              <div className="mt-8 flex flex-wrap justify-center gap-3">
                {actions.map((action, index) => (
                  <Link key={`${action.to}-${index}`} to={action.to}>
                    <Button variant={action.variant || "primary"} size="lg">
                      {action.label}
                    </Button>
                  </Link>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </PageContainer>
    </div>
  );
};

export default ActionStatus;